module.exports = __webpack_public_path__ + "media/images/landing/icon-rewards-awesome-fddcdbb9a538c5afdd4388b9b0d22250.svg";